import { $, addAction, INIT } from '@situation/setdesign.util';
import { sceneController, getSceneDuration } from '../../shared/animations/setup';

/* global ScrollMagic, TweenMax */
addAction(INIT, () => {
    $('.vertical-animation').each((index, element) => {
        const options = { triggerElement: element, triggerHook: 1, duration: getSceneDuration.bind(element) };
        const scene = new ScrollMagic.Scene({ ...options });
        scene.setTween(TweenMax.fromTo(element, 1, { y: '15%' }, { y: '-15%' }));
        scene.addTo(sceneController);
    });
});
